// Monotonic request authority for organization discovery. Dependencies are injected
// so race behavior can be verified without replacing the production state machine.
export function createCohortDiscovery({ listOrgs, getSelection, reconcile }) {
  let revision = 0
  let inFlight = null

  async function refresh({ force = false, suppressRealtimeEnableFor = null } = {}) {
    const selectedId = getSelection()?.id
    if (!force && inFlight?.selectedId === selectedId) return inFlight.promise
    const token = ++revision
    const request = (async () => {
      const discovered = await listOrgs({ force })
      if (token !== revision || getSelection()?.id !== selectedId) return getSelection()
      const nodes = suppressRealtimeEnableFor === selectedId && Array.isArray(discovered)
        ? discovered.map(node => node?.id === selectedId
          ? { ...node, realtime_monitoring_enabled: false }
          : node)
        : discovered
      return reconcile(nodes)
    })()
    const current = { selectedId, promise: request }
    inFlight = current
    try {
      return await request
    } finally {
      if (inFlight === current) inFlight = null
    }
  }

  function invalidate() {
    revision++
    inFlight = null
  }

  function confirmRealtimeRevocation(selectedId = getSelection()?.id) {
    // Invalidate synchronously before issuing a forced, non-deduped confirmation.
    // The realtime endpoint's explicit denial remains authoritative for this pass.
    invalidate()
    return refresh({ force: true, suppressRealtimeEnableFor: selectedId })
  }

  return { refresh, invalidate, confirmRealtimeRevocation }
}
